import { ROUTES } from 'src/constants/routes.const';
import { applyFutureLearnablesOffset } from 'src/utils/futureLearnablesOffset';
import { stringifyUrl } from 'src/utils/stringifyUrl';

export type QuickReviewSessionUrlOptions = {
  source?: string;
  back?: string;
  pathwayCheckpointId?: number;
  futureLearnablesOffset?: number;
};

export const getQuickReviewSessionUrl = (
  languagePairId: number,
  options: QuickReviewSessionUrlOptions = {},
): string => {
  const params: Record<string, string | number> = { language_pair_id: languagePairId };
  if (options.source) {
    params.source = options.source;
  }
  if (options.back) {
    params.back = options.back;
  }
  if (options.pathwayCheckpointId !== undefined) {
    params.pathway_checkpoint_id = options.pathwayCheckpointId;
  }
  applyFutureLearnablesOffset(params, options.futureLearnablesOffset);
  return stringifyUrl(ROUTES.aprender.quickReview, params);
};
